module.exports = __webpack_public_path__ + "img/el-ic-list.59d876d7.svg";